// extracted by mini-css-extract-plugin
export default {"container":"SuccessWindow_container__Q8Hx0","visible":"SuccessWindow_visible__5rA4p","error":"SuccessWindow_error__VCeuX"};